import React, { useEffect, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import SummarySettings from "../WidgetsSettings/Summary/SummarySettingsModal";
import IntlMessages from "@util/IntlMessages";
import { getList } from "services/api/Api";
import { getFile, getFileBytes } from "../../../services/restAPI/RestApi";
import "./summary.less";
import { isActivePublicUser } from "../../../util/Scripts";

const SummaryWidget = ({ value, role }) => {
   const [columns, setColumns] = useState([]);
   const [displayValue, setDisplayValue] = useState("");
   const [imgSrcFromFileId, setImgSrcFromFileId] = useState(null);
   const contentContainerRef = React.useRef();
   useEffect(() => {
      let sum = 0;
      if (value.columnToSummarize) {
         getList(value.listId, 1, value.itemsPerPage).then((res) => {
            const responseData = isActivePublicUser() ? res.data.getPublicList : res.data.default;
            setColumns(responseData.columns);
            responseData.data.map((row) => {
               sum = sum + parseFloat(row[value.columnToSummarize]);
            });
            setDisplayValue(sum);
         });
      }
   }, [value]);
   useEffect(() => {
      if (!value.imageSourceURL && value.imageFileId) {
         getFileBytes(value.imageFileId).then((res) => {
            if (res.data.includes("<svg")) {
               const blob = new Blob([res.data], { type: "image/svg+xml" });
               setImgSrcFromFileId(URL.createObjectURL(blob));
            } else getFile(value.imageFileId).then((res) => setImgSrcFromFileId(res.data));
         });
      }
   }, [value.imageFileId, value.imageSourceURL]);

   const { xsImageSize, smImageSize } = value;
   const contentBox = contentContainerRef?.current?.clientWidth;
   const imageWidth = xsImageSize !== 0 ? (xsImageSize / 100) * contentBox + "px" : "unset";
   const imageHeight = smImageSize !== 0 ? (smImageSize / 100) * contentBox + "px" : "unset";

   return (
      <div className="summaryWidget">
         <Widget
            styleName="gx-m-0"
            bgColor={value.backgroundColourHex}
            className="summaryWidget"
            role={role}
            extra={
               role === "OWNER" || role === "MODERATOR" ? (
                  <SettingsModal
                     widgetName={value.name}
                     widgetId={value.id}
                     icon="setting"
                     deleteIcon="true"
                     children={<SummarySettings value={value} columns={columns} />}
                  />
               ) : null
            }
         >
            <div ref={contentContainerRef}>
               {value.columnToSummarize && value.description ? (
                  <>
                     <div
                        style={{ color: value.textColor }}
                        className="gx-flex-row gx-justify-content-center gx-mb-1 gx-mb-sm-4"
                     >
                        <span
                           className={` gx-flex-row gx-justify-content-center gx-align-items-center`}
                        >
                           {value.imageSourceURL || imgSrcFromFileId ? (
                              <div>
                                 <img
                                    src={value.imageSourceURL || imgSrcFromFileId}
                                    width={imageWidth}
                                    height={imageHeight}
                                    className=" gx-pointer gx-mb-1"
                                    alt=""
                                 />
                              </div>
                           ) : null}
                        </span>
                     </div>
                     <div
                        style={{
                           color: value.textColor,
                           fontSize: "x-large",
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center",
                        }}
                     >
                        <span style={{ color: value.textColor }}>
                           {(Math.round(displayValue * 100) / 100).toFixed(2)}
                        </span>
                        <p className={`gx-mb-0 gx-mb-sm-3`}>{value.description}</p>
                     </div>
                  </>
               ) : (
                  <p className="gx-pl-3">
                     <IntlMessages id="timeline.selectListIdAndAttributes" />
                  </p>
               )}
            </div>
         </Widget>
      </div>
   );
};

export default SummaryWidget;
